;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.Rankings = Marionette.ItemView.extend({
		template: null,
		ui: {
			'swipe_table'    : '',
			'round_select'   : '',
			'sort_th'        : '',
			'load_more'      : '',
			'show_team'      : '',
			'search_me'      : '.js-search-me-rankings',
			'search_me_val'  : '.js-search-me-value',
			'search_me_list' : '.ranking-autocomplete li'
		},
		events: {
			'change @ui.round_select'  : 'changeRound',
			'click @ui.sort_th'        : 'sortTable',
			'click @ui.load_more'      : 'loadMore',
			'click @ui.show_team'      : 'showUserTeam',
			'input @ui.search_me'      : 'getSearchMeMatches',
			'keyup @ui.search_me'      : 'detectEnterEvent',
			'click @ui.search_me_list' : 'findMe'
		},
		onRender: function() {

			this.ui.swipe_table.swipeTable();
			if (this.scroll_pos) {
				this.ui.swipe_table.scrollLeft(this.scroll_pos);
			}

			this._changedFilter = _.debounce(_.bind(this.sendFilterRequest, this), 750);

			if(this.search_val && this.search_val.length){
				this.ui.search_me.focus();
				 this.ui.search_me[0].setSelectionRange( this.search_val.length , this.search_val.length);
			}
		},

		initialize: function() {
			this.showPreloader()
				.scrollToTop();

			this.rankings        = this.getOption('rankings');
			this.rounds          = this.getOption('rounds');
			this.user            = this.getOption('user');
			this.offset          = 0;
			this.limit           = 50;
			this.is_all          = false;
			this.sort_key        = 'rank';
			this.sort_order      = true;
			this.scroll_pos      = null;
			this.reverse_keys    = ['overall_rank', 'rank', 'team_name'];
			this.order_direction = $.inArray(this.sort_key, this.reverse_keys) != -1 ? !this.sort_order : this.sort_order;
			this.autocomplete    = false;
			this.search_val      = '';
			this.cachRankings    = [];

			this.model.set({
				user_id:      '',
				round_id:     '',
				rounds:       '',
				rankings:     '',
				sort_key:     '',
				sort_order:   '',
				is_all:       '',
				avatars_url:  '',
				autocomplete: '',
				search_val:   '',
				only_my:      '',
				is_class_id:  false
			})

			var complete = [
				this.rounds.fetch({ cache: true, expires: 60 }),
				this.rankings.show_team_rankings().fetch({ data:{ order: this.sort_key,
					order_direction: this.order_direction ? 'DESC' : 'ASC', offset: this.offset } })
			];

			$.when.apply(null, complete).done(_.bind(function() {
				this.is_all = this.rankings.length < this.limit;

				this.rankings
					.setAvgRoundPoints()
					.setRankRoundChange();

				return this.setModelData()
						   .render()
						   .hidePreloader();
			}, this));
		},
		initRankingsData: function() {
			this.showPreloader();


			this.scroll_pos      = this.ui.swipe_table.scrollLeft();
			this.order_direction = $.inArray(this.sort_key, this.reverse_keys) != -1 ? !this.sort_order : this.sort_order;

			var data  = { order: this.sort_key, order_direction: this.order_direction ? 'DESC' : 'ASC', offset: this.offset };
			if (this.round_id) {
				data.round = this.round_id
			}

			this.rankings
				.show_team_rankings()
				.fetch({remove: !Boolean(this.offset), data: data})
				.done(_.bind(function() {
					this.is_all = (this.rankings.length - this.offset) < this.limit;
					this.rankings.setAvgRoundPoints().setRankRoundChange();

					return this.setModelData().render().hidePreloader();
				}, this));

			return this;
		},
		setModelData: function() {

			this.model.set({
				user_id:      this.user.get('id'),
				round_id:     this.round_id,
				rounds:       this.rounds.getPlayedRoundsOptions(),
				rankings:     this.rankings.toJSON(),
				sort_key:     this.sort_key,
				sort_order:   this.sort_order,
				is_all:       this.is_all,
				avatars_url:  CONFIG.AVATARS_URL,
				autocomplete: this.autocomplete,
				search_val:   this.search_val
			});

			return this;
		},

		changeRound: function() {

			this.autocomplete = false;
			this.search_val = '';

			this.offset   = 0;
			this.round_id = +this.ui.round_select.val();
			this.rounds.invoke('set', { 'selected': false });
			if (this.round_id) {
				this.rounds.get(this.round_id).set({'selected': true});
			}

			return this.initRankingsData();
		},

		sortTable: function(e) {

			this.autocomplete = false;
			this.search_val = '';

			this.offset = 0;

			var field = $(e.currentTarget).data('sort-field');

			if (field == this.sort_key) {
				this.sort_order = !this.sort_order;
			}
			else {
				this.sort_key = field;
			}

			return this.initRankingsData();
		},

		loadMore: function() {
			this.offset += this.limit;

			return this.initRankingsData();
		},

		getSearchMeMatches: function(e) {

			if ((e.type == 'keyup' && e.keyCode == 13) || e.type == 'click') {

				this.sendFilterRequest(e);
			}
			else {

				this._changedFilter(e);
			}

			return this;
		},

		sendFilterRequest : function(e){

			var $el    = this.ui.search_me,
				el_val = $el.val();

			this.search_val = el_val;
			this.searchError = false;

			if(el_val.length <= 2) {

				if(el_val.length < 2){
					this.searchError = true;
				}

				if(this.checkSpaces(el_val)){
					this.showErrors([{text: 'Team name incorrect, Please ensure you enter the team name correctly' }],'Error');
					this.searchError = true;
				}

			}

			if(this.searchError){
				return this.checkFilterRequest();
			}

			return this.cashRankingsData()
				.autocompleteRequest();
		},

		checkSpaces: function(str){
			var esc = escape(str);
			var res = esc.match(/%20/g);
			return Boolean(res);
		},

		checkFilterRequest: function(){

			this.autocomplete = false;

			if(this.cachRankings.length){
				this.clearCashAndRestoreRankings();
			}

			this.setModelData()
				.render();

			return this;
		},

		autocompleteRequest: function(){

			this.showPreloader();

			this.rankings
				.showSearchAutocomplete()
				.fetch( { data: {q: this.search_val } } )
					.done(_.bind(function(response, xx) {
						if(response.errors.length) {
							this.showErrors(response.error);
						} else {
							this.autocomplete = this.rankings.toJSON().length ? $.extend(true, [], this.rankings.toJSON()) : [{ id: 0 , team_name: "No results"}];
						}

						this.clearCashAndRestoreRankings()
							.highlightSearchWord()
							.setModelData()
							.render()
							.hidePreloader();
					},
					this));
			return this;
		},

		highlightSearchWord: function(){

			var newAutocomplete = [];
			_.each(this.autocomplete, _.bind(function(value, key){

				var reg_search = new RegExp(this.search_val, "i"),
					res = value.team_name.match(reg_search),
					reg_replace = new RegExp(res, "i");

				value.team_name = value.team_name.replace( reg_replace , '<span class="highlight-search-word">'+ res+ '</span>');
				newAutocomplete.push(value);

			}, this));

			this.autocomplete = newAutocomplete;

			return this;
		},

		highlightFindedValue: function(val, key){

			_.each(this.rankings.models, _.bind(function(value , key){

				if(value.get('user_id') == this.findedUser){
					value.set('finded', true);
				}

			}, this));

			return this;
		},

		cashRankingsData: function(){

			this.cachRankings = this.rankings.where({'overall_rank': 1}).length ? $.extend(true, [], this.rankings.toJSON()) : this.cachRankings;

			return this;
		},

		clearCashAndRestoreRankings: function(){

			this.rankings.set(this.cachRankings);
			this.cachRankings = [];

			return this;
		},

		findMe: function(e){

			var $el = $(e.currentTarget),
				user_id = $el.data('id');

			if(user_id == 0){
				return this;
			}

			this.autocomplete = [];

			this.cashRankingsData()
				.userRankingRequest(user_id);

			return this;
		},

		userRankingRequest: function(user_id){

			this.showPreloader();

			this.findedUser = user_id;

			var data = {
				user_id: user_id
			};

			if(this.round_id){
				data.round = this.round_id
			}

			this.rankings
				.showUserRankingsById()
				.fetch({data: {user_id: user_id, round: this.round_id}})
				.done(_.bind(function(response) {

					if (response.errors.length) {
						this.showErrors(response.errors);
					}

					this.is_all = true;

				this.highlightFindedValue()
					.setModelData()
					.render()
					.hidePreloader();
			}, this));

			return this;
		},
		detectEnterEvent: function(e){

			if (e.which == 13) {
				this.getSearchMeMatches(e);
			}
		}


		//TODO@: Cach prev rankings list and clear when search is empty
		//Done
		//TODO@: Style search input and autocomplete list
		//TODO@: Clear list if search input is empty or user clicked on list
		//Done
		//TODO@: Heightlight search words
		//Done
		//TODO : Clear list when sorting

	});

}(window, APP, Backbone, Marionette, $, _));
